import { styled } from '@mui/system';

export const FeedbackContainer = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	marginBottom: theme.spacing(0.5),
	[theme.breakpoints.down('sm')]: {
		marginTop: theme.spacing(1)
	}
}));
